// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__KGQWi","sk-bouncedelay":"Spinner_sk-bouncedelay__6hSN_","bounce1":"Spinner_bounce1__I6YUL","bounce2":"Spinner_bounce2__rNLUl"};